document.addEventListener('DOMContentLoaded', function () {
  const refreshButtons = document.querySelectorAll(
    '.bfwt-brand-score__refresh-btn'
  );
  if (refreshButtons.length) {
    refreshButtons.forEach(function (refreshButton) {
      const defaultLabel = refreshButton.dataset.labelDefault || 'Update now';
      const loadingLabel = refreshButton.dataset.labelLoading || 'Updating...';
      const actionName =
        refreshButton.dataset.action || 'bf_public_recalculate_score';
      const entityField = refreshButton.dataset.entityField || 'post_id';
      const successHash =
        refreshButton.dataset.successHash || 'budgetfitter-score';

      refreshButton.addEventListener('click', async function () {
        if (refreshButton.disabled) {
          return;
        }

        if (window.bfwt_trackEvent) {
          window.bfwt_trackEvent('brand_score_refresh', {
            post_id:
              refreshButton.dataset.postId ||
              refreshButton.dataset.brandId ||
              '',
            entity_type: entityField,
            event_category: 'engagement',
          });
        }

        refreshButton.disabled = true;
        refreshButton.classList.add('is-processing');

        const labelText = refreshButton.querySelector('span:last-child');
        if (labelText) {
          labelText.textContent = loadingLabel;
        }

        const formData = new FormData();
        formData.append('action', actionName);
        formData.append(
          entityField,
          refreshButton.dataset.postId || refreshButton.dataset.brandId || '0'
        );
        formData.append('nonce', refreshButton.dataset.nonce || '');

        try {
          const response = await fetch(
            refreshButton.dataset.ajaxUrl || '/wp-admin/admin-ajax.php',
            {
              method: 'POST',
              body: formData,
            }
          );

          const payload = await response.json();
          if (payload && payload.success) {
            if (successHash) {
              const hashWithPrefix =
                successHash.charAt(0) === '#' ? successHash : '#' + successHash;
              if (window.location.hash !== hashWithPrefix) {
                if (
                  window.history &&
                  typeof window.history.replaceState === 'function'
                ) {
                  window.history.replaceState(
                    null,
                    '',
                    window.location.pathname +
                      window.location.search +
                      hashWithPrefix
                  );
                } else {
                  window.location.hash = hashWithPrefix.substring(1);
                }
              }
            }
            window.location.reload();
            return;
          }

          let message = 'Please try again shortly.';
          if (
            payload &&
            typeof payload.data === 'string' &&
            payload.data.trim() !== ''
          ) {
            message = payload.data;
          } else if (
            payload &&
            payload.data &&
            typeof payload.data.message === 'string' &&
            payload.data.message.trim() !== ''
          ) {
            message = payload.data.message;
          }

          window.BFWT_Toast?.error(message);
        } catch (error) {
          window.BFWT_Toast?.error('Update failed. Please try again.');
        } finally {
          refreshButton.disabled = false;
          refreshButton.classList.remove('is-processing');
          if (labelText) {
            labelText.textContent = defaultLabel;
          }
        }
      });
    });
  }

  const scoreRoot = document.querySelector('.bfwt-brand-score');
  if (!scoreRoot) {
    return;
  }

  const tips = scoreRoot.querySelectorAll(
    '.bfwt-brand-score__info-tip[data-tooltip]'
  );
  if (tips.length) {
    document.body.classList.add('bfwt-has-floating-tooltips');

    const floating = document.createElement('div');
    floating.className = 'bfwt-brand-score__floating-tooltip';
    floating.setAttribute('role', 'tooltip');
    floating.setAttribute('id', 'bfwt-score-tooltip');
    floating.setAttribute('aria-label', 'Score information');
    document.body.appendChild(floating);

    tips.forEach(function (tip) {
      tip.setAttribute('aria-describedby', 'bfwt-score-tooltip');
    });

    let activeTip = null;

    const positionFloating = function (tip) {
      if (!tip) {
        return;
      }

      const rect = tip.getBoundingClientRect();
      const width = floating.offsetWidth || 280;
      const height = floating.offsetHeight || 64;
      const margin = 10;

      let left = rect.left + rect.width / 2 - width / 2;
      left = Math.max(
        margin,
        Math.min(left, window.innerWidth - width - margin)
      );

      let top = rect.top - height - 10;
      if (top < margin) {
        top = rect.bottom + 10;
      }
      if (top + height > window.innerHeight - margin) {
        top = Math.max(margin, window.innerHeight - height - margin);
      }

      floating.style.left = left + 'px';
      floating.style.top = top + 'px';
    };
    const onScrollOrResize = function () {
      if (activeTip) {
        positionFloating(activeTip);
      }
    };

    const showFloating = function (tip) {
      const text = tip.getAttribute('data-tooltip') || '';
      if (!text) {
        return;
      }

      const wasActive = !!activeTip;
      activeTip = tip;
      floating.textContent = text;
      floating.setAttribute('aria-label', text);
      floating.classList.add('is-visible');
      positionFloating(tip);

      if (!wasActive) {
        window.addEventListener('scroll', onScrollOrResize, { passive: true });
        window.addEventListener('resize', onScrollOrResize);
      }
    };

    const hideFloating = function () {
      if (activeTip) {
        activeTip = null;
        floating.classList.remove('is-visible');
        window.removeEventListener('scroll', onScrollOrResize);
        window.removeEventListener('resize', onScrollOrResize);
      }
    };

    tips.forEach(function (tip) {
      tip.addEventListener('mouseenter', function () {
        showFloating(tip);
      });
      tip.addEventListener('focus', function () {
        showFloating(tip);
      });
      tip.addEventListener('mouseleave', function () {
        hideFloating();
      });
      tip.addEventListener('blur', function () {
        hideFloating();
      });
      tip.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (activeTip === tip) {
          hideFloating();
        } else {
          showFloating(tip);
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!activeTip) {
        return;
      }
      const target = event.target;
      if (!(target instanceof Element)) {
        hideFloating();
        return;
      }
      if (!target.closest('.bfwt-brand-score__info-tip')) {
        hideFloating();
      }
    });
  }

  const scrollWrap = scoreRoot.querySelector(
    '.bfwt-brand-score__criteria-scroll'
  );
  const swipeHint = scoreRoot.querySelector('.bfwt-brand-score__swipe-hint');
  if (scrollWrap && swipeHint) {
    const updateSwipeHint = function () {
      const isMobile = window.matchMedia('(max-width: 640px)').matches;
      const hasOverflow = scrollWrap.scrollWidth - scrollWrap.clientWidth > 12;
      const isAtStart = scrollWrap.scrollLeft <= 8;
      const visible = isMobile && hasOverflow && isAtStart;
      swipeHint.classList.toggle('is-visible', visible);
    };

    updateSwipeHint();
    scrollWrap.addEventListener('scroll', updateSwipeHint, { passive: true });
    window.addEventListener('resize', updateSwipeHint);
  }
});
